import * as PIXI from 'pixi.js';
import gsap from "gsap";
import GameManager from '../components/GameManager';
import AssetsManager from '../components/AssetsManager';
import Player from "./Player";
import tools from 'tools';
import config from "config";

export default class Header extends PIXI.Container {
    constructor() {
        super();


        config.challengers = this.challengers = [];

        this.initPlayerPos = window.innerWidth * 0.237;
        this.chalengersBaseScale = .3;
        this.scoreScale = 100 * config.scoreHeaderCoef;
        this.posLimit = window.innerWidth - 50;
        this.scoreSegment = this.posLimit - this.initPlayerPos;
        this.rank = parseInt(tools.range(config.scoreRangeMin, config.scoreRangeMax));
        this.id = config.playersNumber;
        this.i = 0;
        this.posY = 60;

        this.initBackground = this.initBackground.bind(this);

        // Initialize the elements
        this.initBackground();
        this.initPlayer();
        this.initPlayers();


    }

    initBackground() {
        // Init the background of the header
        const barreTexture = AssetsManager.texturesPixi.progressBar;
        this._barre = new PIXI.Sprite(barreTexture);
        this._barre.y = this.posY;
        this._barre.width = window.innerWidth;
        //this._barre.height = 12;
        this._barre.scale.y = 1;
        this.addChild(this._barre);
    }


    initPlayer() {
        // Init the player as competitor
        let playerPhotoUri = GameManager.H5SDK.getPlatform().getPlayerInfo() ? GameManager.H5SDK.getPlatform().getPlayerInfo().playerPic : null;
        config.player = this.player = new Player(playerPhotoUri, config.cadreP1Color, null, this.rank, true);
        this.player.scale.set(.3);
        this.player.y = this.posY;
        this.player.x = this.initPlayerPos;
        this.addChild(this.player);
    }




    initPlayers(callback) {

        console.log("initPlayers");

        for (let i = 0; i < this.challengers.length; i++) {
            this.challengers[i].tween && this.challengers[i].tween.kill();
            this.challengers[i].visible = false;
            this.challengers[i].destroy();
        }

        this.challengers = [];
        this.player.rank = this.rank;

        this.i = 0;
        this.id = 0;


        AssetsManager.resetProfiles((val) => {

            console.log("players:", val)

            this.initFriends();

            this.initLeaderboardInfos();

            for (let i = 0; i < config.playersNumber; i++) {
                this.addNewChallenger(i);
            }

            console.log("challengers >> ", this.challengers)

            this.updateScore(0, 0);

            GameManager.pixiManager.setObjectifDatas();

            config.gameover = false;

            callback && callback();

        });

    }



    initFriends() {
        let i;
        this.firstTime = true;
        config.friendsArray = [];

        for (i = 0; i < AssetsManager.players.length; i++) {
            if (AssetsManager.players[i].isFriend) {
                AssetsManager.players[i].color = AssetsManager.players[i].isRealScore ? "#ffce0a" : "#72f17e";
                AssetsManager.players[i].leaderColor = "#72f17e";
                AssetsManager.players[i].img = AssetsManager.players[i].imguri;
                config.friendsArray.push(AssetsManager.players[i]);
            } else {
                AssetsManager.players[i].color = "#72bbf1";
                AssetsManager.players[i].leaderColor = "#5a7bc3";
            }
        }


        //Remove from bot array
        let noRealScoreFriendId = 0;
        for (i = 0; i < config.friendsArray.length; i++) {

            if (!config.friendsArray[i].isRealScore) {
                if (this.firstTime) {
                    config.friendsArray[i].score = 2000 + Math.random() * 500;
                    this.firstTime = false;
                } else {
                    config.friendsArray[i].score = config.profilesScoreBarStep * (noRealScoreFriendId + 1) + Math.random() * 500;
                    noRealScoreFriendId++;
                }

            }

            for (let j = 0; j < AssetsManager.players.length; j++) {
                if (AssetsManager.players[j] == config.friendsArray[i]) {
                    AssetsManager.players.splice(j, 1);
                }
            }
        }

        tools.shortByKey(config.friendsArray, "score");

        config.friends = [...config.friendsArray];

        // console.log("friends:", config.friends);
        // console.log("friendsArray:", config.friendsArray);

    }




    initLeaderboardInfos() {


        config.currentleaderboard = [];
        config.leaderboardInfos = [];
        for (let j = 0; j < config.playersNumber; j++) {
            let fakeChallenger = { rank: this.rank - j + (config.playersNumber), score: 0, name: AssetsManager.players[j].name, img: AssetsManager.players[j].imguri, color: "#5a7bc3" };
            config.leaderboardInfos.push(fakeChallenger);
        }
        config.leaderboardInfos.push({ rank: this.rank, score: GameManager.BEST_SCORE, name: "You", img: config.player.texture.baseTexture.resource, color: "#ffffff" });

        console.log("leaderboardInfos:", config.leaderboardInfos);

    }




    addNewChallenger(i) {


        this.scoreScale = 100 * config.scoreHeaderCoef;

        let score = ((i + 1) * this.scoreScale * .45) + tools.range(0, this.scoreScale * 0.2) + this.scoreScale * .25;

        let rank = this.rank - i - 1;
        if (rank <= 0) {
            rank = "";
        }

        let profile = null;


        for (let j = 0; j < config.friendsArray.length; j++) {

            if (score >= config.friendsArray[j].score - 100 && score < config.friendsArray[j].score) {
                score -= 100;
            } else if (score >= config.friendsArray[j].score) {
                profile = config.friendsArray[j];
                if (config.friendsArray[j].isRealScore) {
                    score = config.friendsArray[j].score;
                }
                config.friendsArray.splice(j, 1);
                break;
            }

        }

        if (!profile) {
            profile = AssetsManager.players[this.id];
            profile.color = "#72bbf1";
            profile.leaderColor = "#5a7bc3";
        }

        let challenger = new Player(profile.imguri, profile.color, score, rank);
        challenger.name = profile.name;
        challenger.color = profile.leaderColor;
        challenger.scale.set(this.chalengersBaseScale);
        challenger.x = (this.initPlayerPos + (score / this.scoreScale) * this.scoreSegment);
        challenger.score = score;
        challenger.isFriend = profile.isFriend;
        challenger.isRealScore = profile.isRealScore;
        challenger.killed = false;

        challenger.id = i;
        this.i = i;

        challenger.y = this.posY + 5;

        if (this.id < AssetsManager.players.length - 1) {
            this.id++;
        } else {
            this.id = 0;
        }

        if (challenger.x > this.posLimit) {
            challenger.visible = false;
        }

        if (rank != "") {
            this.challengers.push(challenger);
            config.challengers.push(challenger);
            config.leaderboardInfos.push(challenger);
            this.addChild(challenger);
        }

        console.log("config.challengers:",config.challengers)



    }




    resize() {

        // Adjust the barre width
        this._barre.width = window.innerWidth;

        this.initPlayerPos = window.innerWidth * 0.237;
        this.player.x = this.initPlayerPos;


    }

    updateScore(score, time = .5) {


        if (config.gameover) {
            return;
        }


        console.log("updateScore");

        this.playerScore = score;

        let pos;
        let challenger;


        for (let i = 0; i < this.challengers.length; i++) {

            //RESET VALUES "time == 0"
            if (time == 0) {

                this.challengers[i].killed = false;
                this.challengers[i].picto.visible = true;
                this.challengers[i].scale.set(this.chalengersBaseScale);
            }


            pos = (this.initPlayerPos + ((this.challengers[i].score - score) / this.scoreScale) * this.scoreSegment);
            challenger = this.challengers[i];

            if (!challenger.killed) {

                if (pos >= this.posLimit) {

                    challenger.visible = false;
                    challenger.scale.set(0);

                } else if (pos > this.initPlayerPos) {

                    challenger.visible = true;
                    let __scale = .3;
                    challenger.scale.x < __scale && gsap.to(challenger.scale, { delay: .5, duration: .4, x: __scale, y: __scale });
                    challenger.tween = gsap.to(challenger, {
                        duration: time,
                        x: pos,
                        ease: "none"
                    });

                } else {

                    challenger.tween && challenger.tween.kill();
                    challenger.killed = true;

                    gsap.to(challenger, {
                        duration: time,
                        x: this.initPlayerPos,
                        ease: "none",
                        onComplete: e => {
                            gsap.to(e.scale, {
                                duration: .3,
                                x: e.scale.x * .1,
                                y: e.scale.y * 2,
                                ease: "back.in(3)"
                            })

                            gsap.to(e.scale, {
                                delay: .3,
                                duration: .2,
                                x: 0,
                                y: 0,
                                onComplete: (_e) => {
                                    let rand = Math.random();
                                    if (rand >= .4) {
                                        console.log("+4 Coins", _e);
                                        this.addCoins();
                                    } else if (rand < .4 && rand >= .2) {
                                        console.log("+1 Arrow Item Bonus");
                                        this.addBooster();
                                    } else {
                                        console.log("+1 Shield Item Bonus");
                                        this.addShield();
                                    }

                                    this.i++;
                                    _e.visible = false;
                                    this.player.rank = _e.rank;
                                    this.challengers.splice(0, 1);
                                    this.addNewChallenger(this.i);

                                    console.log("challengers:", this.challengers)

                                    // vider la premier case pour faire pousser les autres element suite a l'inserssion de 'You"
                                    config.leaderboardInfos.splice(0, 1);

                                    for (let i = 0; i < config.leaderboardInfos.length; i++) {

                                        if (config.leaderboardInfos[i].name == "You") {
                                            config.leaderboardInfos[i].score = GameManager.BEST_SCORE;
                                            config.leaderboardInfos[i].color = "#ffffff";
                                            let oldRank = config.leaderboardInfos[i].rank;
                                            config.leaderboardInfos[i].rank = config.leaderboardInfos[i + 1].rank
                                            config.leaderboardInfos[i + 1].rank = oldRank;
                                            let loser = config.leaderboardInfos[i + 1];
                                            config.leaderboardInfos[i + 1] = config.leaderboardInfos[i];
                                            config.leaderboardInfos[i] = loser;
                                            i++;
                                        }

                                    }

                                    config.currentleaderboard = [...config.leaderboardInfos];

                                    //

                                },
                                onCompleteParams: [e]
                            });
                        },
                        onCompleteParams: [challenger]
                    });
                }

            }



        }


        config.currentleaderboard = [...config.leaderboardInfos];


    }


    addCoins() {
        GameManager.pixiManager.rewardEffect.add(
            "coins",
            GameManager.pixiManager.header.playerIco.position,
            GameManager.pixiManager.coin.coinPos,
            () => {
                GameManager.COIN += 4;
            }
        );
    }


    addShield() {
        GameManager.pixiManager.rewardEffect.add(
            "shield",
            GameManager.pixiManager.header.playerIco.position,
            GameManager.pixiManager.shieldItems.getBtn.position,
            () => {
                GameManager.pixiManager.shieldItems.add();
            }
        );
    }


    addBooster() {
        GameManager.pixiManager.rewardEffect.add(
            "booster",
            GameManager.pixiManager.header.playerIco.position,
            GameManager.pixiManager.arrowItems.getBtn.position,
            () => {
                GameManager.pixiManager.arrowItems.add();
            }
        );
    }


    restart() {

        console.log("restart");
        this.initPlayers();

    }


    get playerIco() {
        return this.player;
    }



}